import { render, staticRenderFns } from "./EmailFeedback.vue?vue&type=template&id=cc40024e&scoped=true&"
import script from "./EmailFeedback.vue?vue&type=script&lang=ts&"
export * from "./EmailFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./EmailFeedback.vue?vue&type=style&index=0&id=cc40024e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc40024e",
  null
  
)

export default component.exports